<template>
<div :class="{ 'slide-active': isOpenSlideright }">
    <portal target-el="#filter">
        <HeaderActions :isDataExist="indentsCount" :isIndentSelected="selectedIndents.length > 0" :isLoading="isLoading" :invoiceId="getInvoiceId" :isFreightBill="isFreightBill" :isInvoices="isInvoices" :indentsCount="indentsCount" :showMailInvoiceAnnexure="showMailInvoiceAnnexure" :showInvoicePreview="showInvoicePreview" :transporterAnnexureEnabled="transporterAnnexureEnabled" :freightBillNo="getFreightBillNo" :freightBillId="getFreightBillId" :invoiceUuid="invoiceUuid" :invoiceURL="invoiceURL" :viewed="viewed" :total_rows="getTotalRows" @openSummary="openSummary" @onUpload="$emit('onUpload',$event)" @mailAnnexure="$emit('mail-annexure')" @remove="remove" @removeSelectedPayment="removeSelectedPayment" @search="search" 
          :isPaymentRemoveEnabled="paymentRemoveEnabled"
          />
    </portal>
    <div class="payments">
        <div class="table-height mb-20">
            <div class="mt-15" v-for="depot in Object.keys(depotWisePayments)" :key="depot">
              <div class="mx-20"> 
              <h2
                 class="title-status pointer mb-0"
                  v-if="depotVisibility[depot]"
                  style="padding-left: 15px;"
                  @click="() => changeDepotPaymentView(depot)"
                >
                    <strong>
                        {{depotWisePayments[depot].name}}
                    </strong>
                    <span class="ml-5">
                        - {{depotWisePayments[depot].loaded_payments}} loaded of {{depotWisePayments[depot].total_count}} Indents
                    </span>
                    <span v-if="depotWisePayments[depot].status" :class="depotWisePayments[depot].statusClass">
                        {{depotWisePayments[depot].status}}
                    </span>
                    <span v-if="depotWisePayments[depot].depotTotal || depotWisePayments[depot].depotTotal === 0" class="ms-3 amount-tag" style="padding: 0 5px;margin: 0 10px;">
                        {{ $t('DEPOT_TOTAL') }} {{$getIndianFormat(depotWisePayments[depot].depotTotal)}}
                    </span>
                    <span v-if="!depotVisibility[depot].showPayments" class="f-right pr-5 text-capitalize text-xs text-bold">
                        {{ $t('EXPAND') }}
                    </span>
                    <span v-if="depotVisibility[depot].showPayments" class="f-right pr-5 text-capitalize text-xs text-bold">
                        {{ $t('COLLAPSE') }}
                    </span>
                </h2>
                </div>
                <div class="table-containertable mx-20"
                      v-if="depotVisibility[depot].showPayments"
                      :style="{
                        overflowX: screenWidthBasedOverflowValue ? 'auto' : 'hidden',
                        overflowY: 'auto'
                      }">
              <table :style="{width: `${screenWidth}px`}">
              <thead>
                <tr>
                  <th style="width: 280px; max-width: 280px;">
                    <div style="display: flex; align-items: center; justify-content: flex-start; gap: 10px;">
                      <div class="selDropdown arrow-adjust" style="max-width: 100px; flex-shrink: 0; margin-right: 6px;">
                        <Select :value="selectedDisplayOption[depot]" v-model="selectedDisplayOption[depot]"
                          placeholder="Select" value-key="id" popper-class="selListUppercase" style="width: 100%;">
                          <Option v-for="item in displayOptions" :key="item.id"
                            :label="item.tlabel ? $t(item.tlabel) : item.label" :value="item">
                          </Option>
                        </Select>
                      </div>
                      <div
                        style="background-color: rgb(238, 242, 244); color: black; padding: 5px;">
                        <span>{{ $t('VIEWED') }}</span>
                        <span style="color: black;">{{ (viewedObj[depot] && viewedObj[depot].count) || 0 }}</span> /
                        <span style="color: black;">{{ depotWisePayments[depot].depotTotalRecords }}</span>
                      </div>
                    </div>
                  </th>
                  <th style="width: 100px; max-width: 100px;" v-if="isDedicatedTruck && !isFreightBill">{{ $t('EXTRA_KM_CHARGE') }}</th>
                  <th style="width: 100px; max-width: 100px;" v-if="showTransporterDebit">{{ $t('DEBIT_SUB_TOTAL') }}</th>
                  <th :style="{ width: `100px`, minWidth: '100px' }" 
                      v-for="(value, index) in getChargesHeaders.filter(charge => charge.column != 'debit_sub_total')"
                      :key="index">
                    {{ value.tlabel ? $t(value.tlabel) : value.label }}
                  </th>
                  <th v-if="!screenWidthBasedOverflowValue" :style="{ width: `${extraColumnWidthValue}px`, minWidth: '100px' }"></th>
                  <th style="width: 150px; max-width: 150px;text-align: right;padding-right: 20px;">{{ $t('TOTAL') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(indent, index) in depotWisePayments[depot].payments" :key="index"
                  @click="onClickRow(indent, index)">
                  <td style="width: 280px; max-width: 280px;">
                    <div class="checkcontent_block" style="text-align: left; padding-right: 0px;"
                      :class="{ errorcolor:
                      depotWisePayments[depot].indentDetails[index]
                        .isChangedTruck ||
                      depotWisePayments[depot].indentDetails[index]
                        .isMiscChargesChanged }">
                  <div class="d-flex">
                    <div @click.stop class="mr-5">
                      <Checkbox name="checkbox" :value="selectedIndents.includes(depotWisePayments[depot].indentDetails[index].id)" v-if="!isFreightBill && paymentRemoveEnabled" @change="selected($event,depotWisePayments[depot].indentDetails[index].id)" />
                    </div>
                    <div>
                      <div class="tabletitle">
                        <span v-if="isPaymentViewed(depot, index)">
                          <svgicon name="icon-tick-circle" width="14" height="14" />
                        </span>
                        <span v-show="selectedDisplayOption && selectedDisplayOption[depot].id === 0">
                          {{ depotWisePayments[depot].indentDetails[index].order_reference }}
                        </span>
                        <span v-show="selectedDisplayOption && selectedDisplayOption[depot].id === 1">
                          {{ depotWisePayments[depot].indentDetails[index].truck_type }}
                        </span>
                        <span v-show="selectedDisplayOption && selectedDisplayOption[depot].id === 2">
                          {{ depotWisePayments[depot].indentDetails[index].shipment_number }}
                        </span>
                      </div>
                      <div class="location" v-tooltip="indent.tooltipData">
                        {{ depotWisePayments[depot].indentDetails[index].description }}
                      </div>
                      <ul class="rightalignblock">
                        <li class="arrowError" v-if="depotWisePayments[depot].indentDetails[index].utilization_indicator">
                          <svgicon name="arrow" width="8" height="8" :original="false"
                            :class="{ 'svg-down': depotWisePayments[depot].indentDetails[index].utilization_indicator === utilizationIndicator.LOW }" />
                          UT
                        </li>
                      </ul>
                      <ul class="rightalignblock icon-list">
                        <li v-if="depotWisePayments[depot].indentDetails[index].isOpenOrder">
                          <svgicon name="icon-lock-open" width="14" height="13" />
                        </li>
                        <li v-if="depotWisePayments[depot].indentDetails[index].has_comment">
                          <svgicon name="icon-comment" width="13" height="12" />
                        </li>
                        <li v-if="depotWisePayments[depot].indentDetails[index].isRoundTrip">
                          <svgicon name="icon-roundtrip" width="14" height="14" />
                        </li>
                        <li v-if="getMovement(depotWisePayments[depot].indentDetails[index].movementType)">
                          <svgicon :name="getMovement(depotWisePayments[depot].indentDetails[index].movementType).icon" width="8" height="8" />
                        </li>
                      </ul>
                    </div>
                  </div>
                    </div>
                  </td>
                  <td style="width: 100px; max-width: 100px;" v-if="isDedicatedTruck && !isFreightBill">{{ getExtraKmCharge(indent) }}</td>
                  <td style="width: 100px; max-width: 100px;" v-if="showTransporterDebit"
                    :class="{ 'text-red': getTransporterDebitAdjust(indent).transporter_debit_adjust }">
                    {{ getTransporterDebitAdjust(indent).debitSubtotal }}
                  </td>
                  <td
                    :style="{ width: `100px`, minWidth: '100px' }"
                    v-for="(value, chargeIndex) in getChargesHeaders.filter(charge => charge.column != 'debit_sub_total')"
                    :key="chargeIndex"
                    :class="{ 'text-blue': depotWisePayments[depot].systemCharges[index][value.column] !== indent[value.column] }">
                    {{ indent[value.column] || indent[value.column] === 0 ? indent[value.column] : (isSapChargeEnabled ? 'NA' : '') }}
                  </td>
                  <td v-if="!screenWidthBasedOverflowValue" :style="{ width: `${extraColumnWidthValue}px`, minWidth: '100px' }" style="background: #f8f8f8;
                  border: transparent;"></td>
                  <td style="width: 150px; max-width: 150px; text-align: right;padding-right: 20px;">{{ getTotalArray[indent.consigneeId] }}</td>
                </tr>
              </tbody>
            </table>
            <infinite-loading :distance="372" :identifier="new Date()"
              @infinite="($state) => infiniteHandler($state, depot)" force-use-infinite-wrapper=".table-containertable">
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
          </div>
            </div>
        </div>
    </div>
    <div class="tablefooter">
        <div class="row align-items-center">
            <div class="col-lg-4">
                <div class="tablefooter-count">
                    <span class="tablefooter-title">{{ $t('TOTAL_INDENTS') }}:</span>
                    <span class="tablefooter-value">{{indentsCount}}</span>
                </div>
            </div>
            <div class="col-lg-4 aligncenter">
            </div>
            <div class="col-lg-4 floatright">
                <div v-if="!isFreightBill" class="tablefooter-count row rightalignment">
                    <span class="tablefooter-title col-md-auto">{{ $t('REQUESTED') }}</span>
                    <span class="tablefooter-value col-md-auto tooltipstyle">
                      <Tooltip class="item" effect="dark" placement="top" v-if="!isHideSystemCharge">
                          <div slot="content" class="tooltipcontent">
                            {{ $t('SYSTEM_GENERATED') }}
                            <br>
                            {{ $getIndianFormat(systemTotal) }}
                          </div>
                          <div>
                            {{ $getIndianFormat(systemTotal) }}
                          </div>
                      </Tooltip>
                        <div v-else-if="requestedTotal === 0 || requestedTotal">
                            {{$getIndianFormat(requestedTotal)}}
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <Dialog :close-on-click-modal="false" :visible.sync="rowClicked" :append-to-body="true" :center="false" middle="true" width="500px" class="default-dialog dialog-boxed fixed-height">
        <div v-if="showTable" slot="title" class="el-dialog__title">{{rowTitle}} / {{locationDescription}}</div>
        <div v-if="showList" slot="title" class="el-dialog__title">
            <div>
                {{ headerValue }}
            </div>
            <div class="text-sm mt-10 text-grey-dark2">
                {{ searchResult.length }} Result(s)
            </div>
        </div>
        <payment-list v-if="showList" :data="searchResult" @onClick="onClick" />
        <row-details v-if="showTable" :isLoadingDetails="isLoadingDetails" :indent="indent" :orderType="orderType" :extraKmCharge="extraKmCharge" :initialExtraKmCharge="initialExtraKmCharge" :paymentSettings="currentClientConfig.payment_settings" :rowInfo="rowInfo" :rowChargeStatus="rowChargeStatus" :filteredChargesHeaders="getChargesHeaders" :paymentId="paymentId" :consigneeDataId="consigneeDataId" :editable="editable" :chargeComments="chargeComments" :showTransporterDebit="showTransporterDebit" :debitAdjustCharge="debitAdjustValue" :activeName="activeTabName" :orderMovement="orderMovement" :clientConfig="currentClientConfig" :isShipperChargesFeatureEnabled="isShipperChargesFeatureEnabled" @save="save" @showPreview="showPreview" />
    </Dialog>
    <Dialog :visible.sync="previewDialogVisible" class="modal-mt" :modal="false">
        <img width="100%" :src="dialogImageUrl" alt="" />
    </Dialog>
</div>
</template>

<script>
import {
  movementTypes,
} from '@/constants/indentConstants';
import {
  displayOptions,
  status,
} from '@/constants/payments';
import chargesHeaders from '@common/constants/IndentCharges';
import {
  getDummyObj,
  getStatusById,
  getStatusByName,
  getTransporterCharges,
  hasTransporterEditedCharges,
  isChangedTruckType,
  isInvoiceSignatureEnabled,
  isOpenOrder,
} from '@common/lib/payments';
import {
  cloneDeep,
  groupBy,
  isEmpty,
} from 'lodash';
import moment from 'moment';
import PerfectScrollbar from 'perfect-scrollbar';
import {
  mapGetters,
} from 'vuex';
import HeaderActions from './HeaderActions';
import PaymentList from './PaymentList';
import RowDetails from './RowDetails';

import {
  ChargesBy,
  Movement,
  deliveryType,
  utilizationIndicator,
} from 'pando-constants';

export default {
  props: {
    indentDetails: {
      type: Array,
      default: () => [],
    },
    isDedicatedTruck: {
      type: Boolean,
      default: false,
    },
    invoiceStatus: {
      type: Boolean,
      default: false,
    },
    invoiceURL: {
      type: String,
      default: null,
    },
    extraKmCharge: {},
    initialExtraKmCharge: {
      type: Number,
      default: 0,
    },
    indentsCount: {},
    isOpenSummary: {},
    editable: {
      type: Boolean,
      default: false,
    },
    isShipperChargesFeatureEnabled: {
      type: Boolean,
      default: false,
    },
    isInvoices: {},
    isFreightBill: false,
    transporterAnnexureEnabled: {
      type: Boolean,
      default: false,
    },
    freightBillDetails: {
      type: Object,
    },
    depotWiseDetails: {
      type: Object,
    },
    currentInvoiceStatus: {
      type: Number,
    },
    invoiceUuid: {
      type: String,
      required: true,
    },
    eInvoiceEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HeaderActions,
    RowDetails,
    PaymentList,
  },
  // mixins: [TableMixin],
  data() {
    return {
      viewed: 0,
      viewedObj: {},
      rowClicked: false,
      rowInfo: {},
      utilizationIndicator,
      checked: false,
      isActive: false,
      chargesHeaders,
      movementTypes,
      centerDialogVisible: false,
      selectedDisplayOption: {},
      selectedIndent: null,
      selectedIndents: [],
      actualTotalValues: {},
      requestedTotal: 0,
      isOpenSlideright: false,
      noRecords: false,
      displayOptions,
      errorArray: [],
      activeTab: 'details',
      statusClassMap: status,
      removedIndentNull: false,
      statusPriorityOrder: [
        getStatusByName('invoice_cancelled').id,
        getStatusByName('rejected').id,
        getStatusByName('paid').id,
        getStatusByName('on_hold').id,
        getStatusByName('posted').id,
        getStatusByName('generated').id,
        getStatusByName('invoice_approved').id,
        getStatusByName('checked').id,
        getStatusByName('re_submitted').id,
        getStatusByName('invoice_returned').id,
      ],
      depotVisibility: {},
      activeName: null,
      dialogVisible: false,
      disabled: false,
      indent: {},
      paymentId: null,
      transporterDebitCharge: {},
      rowTitle: null,
      locationDescription: null,
      rowChargeStatus: {},
      orderType: null,
      chargeComments: {},
      consigneeDataId: null,
      debitAdjustValue: 0,
      activeTabName: null,
      isLoadingDetails: false,
      previewDialogVisible: false,
      showList: false,
      showTable: false,
      dialogImageUrl: '',
      searchResult: null,
      orderMovement: null,
      headerValue: null,
      screenWidth: process.client ? window.innerWidth : 0,
    };
  },
  mounted() {
    this.screenWidth = window.innerWidth;
    window.addEventListener("resize", this.updateWidth);
    // the below code is for scroll formatting in table
    const container = this.$el.querySelector('.el-table__body-wrapper');
    if (container) {
      // eslint-disable-next-line no-unused-vars
      const ps = new PerfectScrollbar(container, {
        minScrollbarLength: 20,
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
      currentTransporter: 'app/currentTransporter',
      currentClientConfig: 'app/currentClientConfig',
      isLoading: 'paymentsV2/isLoading',
      hasEmpty: 'paymentsV2/hasEmpty',
      systemTotal: 'paymentsV2/totalSystemCharges',
      actualRequestedTotal: 'paymentsV2/totalTransporterCharges',
      isRejected: 'paymentsV2/isRejected',
      uploadResponse: 'paymentsV2/uploadResponse',
    }),
    indentDisplayOptions() {
      return this.displayOptions.filter(displayOption => !displayOption.hide_option_config ||
                (this.currentClientConfig.payment_settings &&
                    !this.currentClientConfig.payment_settings[displayOption.hide_option_config]));
    },
    attachmentsCountBadge() {
      return this.attachments && this.attachments.length > 1 ? this.attachments.length - 1 : 0;
    },
    windowHeight() {
      return '420px';
    },
    paymentRemoveEnabled() {
      const invoiceReturnedStatusId = getStatusByName('invoice_returned') ? getStatusByName('invoice_returned').id : null;
      return this.currentInvoiceStatus === invoiceReturnedStatusId && this.$hasFeature('payment_update_to_invoice');
    },
    getSelectedIndent() {
      return this.selectedIndent;
    },
    screenWidthBasedOverflowValue() {
      return (
        (this.getChargesHeaders.length * 100) +
        (this.showTransporterDebit ? 100 : 0) +
        (this.isDedicatedTruck && !this.isFreightBill ? 100 : 0) +
        (this.isOpenSummary ? 400 : 0)
      ) > (this.screenWidth - 430);
    },
    extraColumnWidthValue() {
      return ((this.screenWidth - 430 - this.getChargesHeaders.length * 100 - (this.showTransporterDebit ? 100 : 0) - (this.isDedicatedTruck && !this.isFreightBill ? 100 : 0)))
    },
    findCategory() {
      const categories = this.currentClientConfig && this.currentClientConfig.freight_bill &&
                this.currentClientConfig.freight_bill.categories;
      return categories && categories.find(cat => this.freightBillDetails &&
                (cat.short_code === this.freightBillDetails.category));
    },
    showMailInvoiceAnnexure() {
      let canShow = this.findCategory ? this.findCategory.show_mail_invoice_annexure : true;
      if (isInvoiceSignatureEnabled(this.currentClientConfig) && !this.eInvoiceEnabled) {
        canShow = canShow && this.isSignatureVerified;
      }
      return canShow;
    },
    showInvoicePreview() {
      let canShow = this.findCategory ? this.findCategory.show_invoice_preview : true;
      if (isInvoiceSignatureEnabled(this.currentClientConfig) && !this.eInvoiceEnabled) {
        canShow = canShow && this.isSignatureVerified;
      }
      return canShow;
    },
    isSignatureVerified() {
      const allowedStatuses = ['Checked', 'Approved', 'Paid', 'On-Hold'];
      const allowedStatusIds = this.statusClassMap
        .filter(statusClass => allowedStatuses.includes(statusClass.name))
        .reduce((acc, statusClass) => {
          acc.push(...statusClass.ids);
          return acc;
        }, []);
      return (allowedStatusIds.includes(this.currentInvoiceStatus));
    },
    depotWisePayments() {
      const totalObj = {};
      let iterator = 0;
      const result = {};
      const depots = Object.keys(this.depotWiseDetails);
      const depotVisibility = this.depotVisibility;
      for (let i = 0; i < depots.length; i += 1) {
        const depot = depots[i];
        this.selectedDisplayOption = {
          ...this.selectedDisplayOption,
          [depot]: this.indentDisplayOptions[0],
        };
        const depotDetails = this.depotWiseDetails[depot];
        const depotStatus = depotDetails.status;
        result[depot] = {
          statusCode: depotStatus,
          status: depotStatus && (this.getStatusClass(depotStatus) &&
                        this.getStatusClass(depotStatus).name),
          statusClass: depotStatus && (getStatusById(depotStatus) &&
                        `status-tag tag-${this.getStatusClass(depotStatus).color.toLowerCase()}`),
          name: depotDetails.name || 'unknown',
          total_count: depotDetails.count,
          loaded_payments: depotDetails.loaded_payments,
          indentDetails: [],
          payments: [],
          systemCharges: [],
          depotTotal: depotDetails.depot_total,
          depotTotalRecords: depotDetails.total_depot_records,
        };
        if (!depotVisibility[depot]) {
          depotVisibility[depot] = {
            showPayments: false,
            userClicked: false,
          };
        }
        if (!depotVisibility[depot].userClicked) {
          if (result[depot].statusCode === getStatusByName('invoice_approved').id && i !== 0) {
            depotVisibility[depot].showPayments = false;
          } else {
            depotVisibility[depot].showPayments = true;
          }
        }
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.depotVisibility = depotVisibility;
      if (this.indentDetails) {
        for (let indentIdx = 0; indentIdx < this.indentDetails.length; indentIdx += 1) {
          const indent = this.indentDetails[indentIdx];
          let depot;
          if ([Movement.PRIMARY, Movement.SECONDARY].includes(indent.movement)) {
            depot = indent.source_location_id;
          } else if ([Movement.VENDOR, Movement.RETURN].includes(indent.movement)) {
            depot = indent.location_ids.destination_location_ids[0];
          }
          const destination = this.getDestination(indent);
          const dropItems = this.getDropItems(indent);
          const areSameGroup = this.areSameGroupConsignees(indent);
          const openOrderBool = isOpenOrder(indent.order_type);
          const baseOrderDetails = {
            id: indent.id,
            isOpenOrder: openOrderBool,
            delivery_type: indent.delivery_type,
            order_type: indent.order_type,
            order_reference: indent.order_reference,
            order_no: indent.order_no,
            truck_type: indent.truck_type,
            utilization_indicator: indent.utilization_indicator,
            isChangedTruck: isChangedTruckType(indent) &&
                            !this.currentClientConfig.payment_settings.hide_transporter_truck_type,
            shipment_number: indent.shipment_number,
            movement: indent.movement,
          };
          for (let consigneeIdx = 0; consigneeIdx < indent.consignee_data.length; consigneeIdx += 1) {
            const consignee = indent.consignee_data[consigneeIdx];
            if (consignee.charges) {
              let description;
              if (areSameGroup) {
                description = consignee.display_reference_name || consignee.city;
              } else if (dropItems.length > 1) {
                description = 'Multidrop';
              } else if (destination) {
                description = destination.display_reference_name || destination.city;
              } else {
                description = consignee.name;
              }
              const tooltipData = (dropItems.length > 1 && !areSameGroup) ? dropItems : null;
              const transCharges = getTransporterCharges(consignee.charges);
              const value = {
                indentIndex: indentIdx,
                indexValue: iterator,
                id: indent.id,
                movementType: indent.movement,
                consigneeId: consignee.id,
                isRoundTrip: (indent.child_indent_ids && indent.child_indent_ids.length > 0) ||
                                    (!!indent.parent_indent_id),
                description,
                tooltipData,
                isOpenOrder: openOrderBool,
                charges: consignee.charges,
                discrepancyCharges: consignee.discrepancyCharges,
                total: transCharges.total_amount,
                isMiscChargesChanged: hasTransporterEditedCharges(consignee.charges),
                depot_id: indent.depot_id,
                ...baseOrderDetails,
              };
              const payment = {
                indexValue: iterator,
                depotId: depot,
                consigneeId: consignee.id,
                has_comment: consignee.has_comment,
                ...consignee.charges.find(charge => charge.charges_by === ChargesBy.TRANSPORTER),
              };
              result[depot].payments.push(payment);
              result[depot].systemCharges.push(consignee.charges.find(charge => charge.charges_by === ChargesBy.SYSTEM));
              result[depot].indentDetails.push(value);
              iterator += 1;
              const obj = getDummyObj(consignee.id, transCharges.total_amount);
              Object.assign(totalObj, obj);
            }
          }
          if (!indent.consignee_data.length) {
            const dummyConsigneeId = `dummy_consignee_id_${(Math.random() * 10000).toFixed(0)}`;
            baseOrderDetails.consigneeId = dummyConsigneeId;
            baseOrderDetails.charges = [{
              contract_charge: indent.contract_charge,
              extra_km_charge: indent.extra_km_charge || 0,
              charges_by: ChargesBy.TRANSPORTER,
            }];
            const payment = {
              indexValue: iterator,
              depotId: depot,
              consigneeId: dummyConsigneeId,
              has_comment: false,
              ...baseOrderDetails.charges.find(charge => charge.charges_by === ChargesBy.TRANSPORTER),
            };
            result[depot].payments.push(payment);
            result[depot].indentDetails.push({
              indexValue: iterator,
              ...baseOrderDetails,
            });
            iterator += 1;
            const obj = getDummyObj(dummyConsigneeId, indent.indent_total_charge);
            Object.assign(totalObj, obj);
          }
        }
      }
      this.actualTotalValues = totalObj;
      return result;
    },
    isPaymentViewed() {
      return (depot, index) => {
        return (
          this.viewedObj &&
          this.viewedObj[depot] &&
          this.viewedObj[depot].payments &&
          this.viewedObj[depot].payments[index]) || false;
      };
    },
    getTotalRows() {
      let totalRows = 0;
      Object.keys(this.depotWisePayments).forEach((key) => {
        if (this.depotWisePayments[key].hasOwnProperty('depotTotalRecords')) {
          totalRows += this.depotWisePayments[key].depotTotalRecords;
        }
      });
      return totalRows;
    },
    getTotalArray() {
      const computedTotal = this.actualTotalValues;
      const requestedTotal = this.actualRequestedTotal;
      this.requestedTotal = requestedTotal;
      return computedTotal;
    },
    getTableClass() {
      return (this.indentsCount === 0) ? 'indentemptyState' : '';
    },
    getInvoiceId() {
      return this.indentDetails[0] && this.indentDetails[0].invoice_id;
    },
    isHideSystemCharge() {
      const {
        payment_settings: paymentSettings,
      } = this.currentClientConfig;
      return paymentSettings &&
                paymentSettings.column_hide_view &&
                Object.values(paymentSettings.column_hide_view).some(Boolean);
    },

    getChargesHeaders() {
      const {
        payment_settings: paymentSettings,
      } = this.currentClientConfig;
      let headers = this.chargesHeaders;
      const customCharges = [];
      if (this.indentDetails && this.indentDetails.length) {
        const uniqHash = {};
        this.indentDetails.forEach((indent) => {
          if (indent.custom_charges) {
            indent.custom_charges.forEach((chargeDetails) => {
              if (!uniqHash[chargeDetails.name]) {
                customCharges.push(chargeDetails);
                uniqHash[chargeDetails.name] = true;
              }
            });
          }
        });
      }
      if (paymentSettings && paymentSettings.payment_charges_column_display) {
        headers = headers.filter(header =>
          paymentSettings.payment_charges_column_display[header.column]);
      }
      if (this.freightBillDetails && this.freightBillDetails.applicable_charges) {
        const applicableCharges = this.freightBillDetails.applicable_charges;
        headers = headers.filter(header => applicableCharges.includes(header.column));
      }
      // Base freight (contract_charge) now follows transporter_charge_editable config
      // manually adding custom chargee headers
      if (customCharges.length) {
        const lastHeaderId = headers.reduce((acc, header) => (header.id > acc ? header.id : acc), 0);
        customCharges.forEach((chargeDetails, i) => {
          // For SAP clients, all charges are read-only (fetched from S3)
          const isReadOnly = this.isSapChargeEnabled ? false : (!chargeDetails.is_editable || false);
          headers.push({ id: lastHeaderId + i + 1, column: `custom_${chargeDetails.name}`, class: 'w100', label: chargeDetails.label, tlabel: chargeDetails.label, readOnly: isReadOnly });
        });
      }
      return headers;
    },
    isSapChargeEnabled() {
      // Check if SAP charge integration feature is enabled
      return this.currentClient && this.currentClient.features &&
        this.currentClient.features.includes('sap_charge_integration');
    },
    showTransporterDebit() {
      const {
        payment_settings: paymentSettings,
      } = this.currentClientConfig;
      return paymentSettings.transporter_debit_adjust;
    },
    getFreightBillNo() {
      return this.freightBillDetails && this.freightBillDetails.bill_no;
    },
    getFreightBillId() {
      return this.freightBillDetails && this.freightBillDetails.id;
    },
    getTransporterDebitAdjust() {
      return row => ({
        debitSubtotal: row.debitSubtotal,
        transporter_debit_adjust: row.transporter_debit_adjust,
      });
    },
  },
  methods: {
    updateWidth() {
      this.screenWidth = window.innerWidth;
    },
    areSameGroupConsignees(indent) {
      const consigneeGroups = Object.keys(groupBy(indent.consignee_data, 'group'));
      return (indent.delivery_type === deliveryType.FTL &&
                consigneeGroups.length === 1 && consigneeGroups[0] !== 'undefined');
    },
    getDropItems(indent) {
      let result = [];
      if (indent.consignee_data.length) {
        result = indent.delivery_type === deliveryType.FTL &&
                    indent.consignee_data.map(drop => drop.display_reference_name || drop.city);
      }
      return result;
    },
    showPreview(data) {
      this.previewDialogVisible = data.dialogVisible;
      this.dialogImageUrl = data.dialogImageUrl;
    },
    removeAttachment(file) {
      this.$emit('removeAttachments', file);
    },
    changeDepotPaymentView(depot) {
      const depotVisibility = cloneDeep(this.depotVisibility);
      depotVisibility[depot] = {
        showPayments: !this.depotVisibility[depot].showPayments,
        userClicked: true,
      };
      this.depotVisibility = depotVisibility;
    },
    getDestination(indent) {
      let result = {};
      if (indent.consignee_data.length) {
        result = indent.delivery_type === deliveryType.FTL &&
                    indent.consignee_data.reduce((a, b) => {
                      const date1 = moment(a.arrived_at);
                      const date2 = moment(b.arrived_at);
                      return date1.diff(date2) ? a : b;
                    });
      }
      return result;
    },
    getStatusClass(currentStatus) {
      return this.statusClassMap.find(i => i.ids && i.ids.includes(currentStatus));
    },
    findCurrentStatus(paymentId, currentStatusCode) { // Currently not in use
      const paymentChargeStatuses = this.freightBillDetails &&
                this.freightBillDetails.payment_charge_status;
      let resultStatus = currentStatusCode;
      if (paymentChargeStatuses) {
        Object.keys(paymentChargeStatuses[paymentId]).forEach((key) => {
          if (this.statusPriorityOrder.indexOf(paymentChargeStatuses[paymentId][key]) >
                        this.statusPriorityOrder.indexOf(currentStatusCode)) {
            resultStatus = paymentChargeStatuses[paymentId][key];
          }
        });
      }
      return resultStatus;
    },
    getMovement(movement) {
      return this.movementTypes.find(val => val.id === movement);
    },
    infiniteHandler($state, depot) {
        this.$emit('loadMore', $state, depot);
    },
    openSummary() {
      this.isOpenSlideright = false;
      this.$emit('openSummary');
    },
    selected(value, row) {
      if (value) {
        this.selectedIndents.push(row);
      } else {
        this.selectedIndents = this.selectedIndents.filter(val => val !== row);
      }
    },
    remove() {
      const selectedIndents = [];
      const filtreredIndents = [];
      this.indentDetails.forEach((indent) => {
        if (this.selectedIndents.includes(indent.id)) {
          selectedIndents.push(indent);
        } else {
          filtreredIndents.push(indent);
        }
      });
      this.$store.commit('paymentsV2/replaceIndentDetails', filtreredIndents);
      this.$emit('selectedIndentsUpdate', this.selectedIndents);
      let totalRemoved = 0;
      selectedIndents.forEach((indent) => {
        const consignees = indent.consignee_data || [];
        consignees.forEach((consigneeData) => {
          const charges = consigneeData.charges.find(charge =>
            charge.charges_by === ChargesBy.TRANSPORTER);
          totalRemoved += charges.total_amount;
        });
      });
      this.requestedTotal = this.requestedTotal - totalRemoved;
      this.$store.commit('paymentsV2/setTotalTransporterCharges', this.requestedTotal);
      this.selectedIndents = [];
      if (!filtreredIndents.length) {
        this.removedIndentNull = true;
      }
    },
    removeSelectedPayment() {
      this.$emit('removePaymentFromInvoice', [...this.selectedIndents]);
    },
    getExtraKmCharge(charges) {
      return charges.extra_km_charge;
    },
    updateExtraKMCharge(data) {
      const tempIndents = this.indentDetails;
      const indentIndex = tempIndents.findIndex(item => item.id === data.payment_id);
      if (data.extra_km_charge) {
        const initialExtraKmCharge = tempIndents[indentIndex].extra_km_charge;
        tempIndents[indentIndex].indent_total_charge += (data.extra_km_charge - initialExtraKmCharge);
        tempIndents[indentIndex].extra_km_charge = data.extra_km_charge;
      }
      this.$store.commit('paymentsV2/replaceIndentDetails', tempIndents);
    },

    callGA(eventName, label) {
      this.$addGAEvent('Transporter - Pay', eventName, `Transporter - Indent Details:${label}`);
    },
    filterBasedOnLrNumber(consigneeData, lrNumber) {
      return consigneeData.reduce((acc, consignee) => {
        const lrNumbers = consignee.lr_numbers.filter(lr => lr.includes(lrNumber));
        if (lrNumbers.length) {
          acc.push(consignee);
        }
        return acc;
      }, []);
    },
    getPresentablePayments(payments, searchParams) {
      const result = [];
      for (let idx = 0; idx < payments.length; idx += 1) {
        const payment = payments[idx];
        const baseOrderDetails = {
          id: payment.id,
          order_no: payment.order_no,
          order_reference: payment.order_reference,
          order_type: payment.order_type,
          delivery_type: payment.delivery_type,
        };
        const destination = this.getDestination(payment);
        if (searchParams.lr_number && payment.delivery_type === deliveryType.PTL) {
          payment.consignee_data = this.filterBasedOnLrNumber(payment.consignee_data, searchParams.lr_number);
        }
        for (let consigneeIdx = 0; consigneeIdx < payment.consignee_data.length; consigneeIdx += 1) {
          const consignee = payment.consignee_data[consigneeIdx];
          if (consignee.charges) {
            const value = {
              consigneeId: consignee.id,
              description: destination ? destination.city : consignee.name,
              ...baseOrderDetails,
            };
            result.push(value);
          }
        }
      }
      return result;
    },
    async search(searchParams) {
      this.headerValue = searchParams.order_number || searchParams.shipment_number ||
                searchParams.lr_number;
      const invoiceId = this.getInvoiceId;
      if (invoiceId) {
        const params = {
          invoiceId,
          search: true,
          ...searchParams,
        };
        const result = await this.$store.dispatch('paymentsV2/getInvoicePaymentsList', params);
        this.searchResult = this.getPresentablePayments(result.data.payments, searchParams);
      } else {
        const params = {
          payment_ids: this.$route.query.ids,
          freight_bill_id: this.$route.query.freightBillId,
          show: 'consumed_capacity,charges,payment_discrepencies',
          ...searchParams,
        };
        const result = await this.$store.dispatch('paymentsV2/getPaymentsList', params);
        this.searchResult = this.getPresentablePayments(result.payments, searchParams);
      }
      if (this.searchResult.length) {
        this.rowClicked = true;
        if (this.searchResult.length > 1) {
          this.showList = true;
          this.showTable = false;
        } else {
          this.onClick(this.searchResult[0]);
        }
      } else {
        this.$errorMessage({
          message: 'No Shipment found - Please check keyword and try again',
        });
      }
    },
    onClick(item) {
      this.showList = false;
      this.showTable = true;
      this.activeTabName = 'Charges';
      this.isLoadingDetails = true;
      this.getIndentDetails(item);
    },
    async onClickRow(item, event) {
      if (this.isOpenSummary) {
        return;
      }
      if (event.label === 'INDENT') {
        this.activeTabName = 'Details';
      } else {
        this.activeTabName = 'Charges';
      }
      this.showList = false;
      this.showTable = true;
      this.isLoadingDetails = true;
      this.rowClicked = true;
      const indentDetail = this.depotWisePayments[item.depotId].indentDetails;
      const payments = this.depotWisePayments[item.depotId].payments;
      const indentRow = indentDetail.find(
        indent => indent.indexValue === item.indexValue,
      );
      const paymentRow = payments.find(
        payment => payment.indexValue === item.indexValue,
      );
      const paymentRowIndex = paymentRow.indexValue;
      if (paymentRowIndex !== -1) {
        const depotPayments = this.depotWisePayments[item.depotId].payments;
        const paymentIndex = depotPayments.findIndex(payment => payment.indexValue === paymentRowIndex);

        if (paymentIndex !== -1) {
          if (!this.viewedObj[item.depotId]) {
            this.$set(this.viewedObj, item.depotId, { count: 0, payments: {} });
          }
          const viewedData = this.viewedObj[item.depotId];
          if (!viewedData.payments[paymentIndex]) {
            this.$set(viewedData.payments, paymentIndex, true);
            this.$set(this.viewedObj, item.depotId, {
              count: viewedData.count + 1,
              payments: viewedData.payments,
            });
            this.viewed += 1;
          }
        }
      }
      this.getIndentDetails(indentRow);
    },
    async getIndentDetails(indentRow) {
      const params = {
        payment_id: indentRow.id,
        consignee_data_id: indentRow.consigneeId,
      };
      const indentCharges = await this.$store.dispatch('paymentsV2/getIndentChargeDetails', params);
      if (indentCharges && indentCharges.errors) {
        this.$errorMessage({
          message: indentCharges.errors,
        });
      } else if (indentCharges && indentCharges.data) {
        this.consigneeDataId = indentRow.consigneeId;
        this.rowTitle = indentRow.order_no;
        this.locationDescription = indentRow.description;
        this.orderType = indentRow.order_type;
        this.orderMovement = indentRow.movement;
        this.rowInfo = indentCharges.data && indentCharges.data.paymentChargesData;
        this.rowChargeStatus = indentCharges.data && indentCharges.data.paymentChargeStatus &&
                    indentCharges.data.paymentChargeStatus[indentRow.id];
        this.chargeComments = indentCharges.data && indentCharges.data.commentsData;
        const result = await this.$store.dispatch(
          'paymentsV2/getIndentDetailsTimelines', {
            payment_id: indentRow.id,
          },
        );
        if (result && result.errors) {
          this.$errorMessage({
            message: result.errors,
          });
        } else if (result && result.data) {
          this.paymentId = indentRow.id;
          if (indentRow.delivery_type === deliveryType.PTL) {
            result.data.consignee_data = result.data.consignee_data.filter(consignee =>
              consignee.id === indentRow.consigneeId);
          }
          this.indent = result.data;
          this.debitAdjustValue = cloneDeep(this.indent.consignee_data[0].transporter_debit.transporter_debit_adjust || 0);
        }
        this.isLoadingDetails = false;
      }
    },
    save(updatedData, closeDialog = true) {
      if (closeDialog) {
        this.rowClicked = false;
      }
      this.$store.commit('paymentsV2/updateIndentDetailCharges', updatedData);
    },
  },
};
</script>

<style lang="scss">
.ps__rail-x {
    margin: 0 130px 0 230px;
}
.el-icon-close:before {
    content: "\E60F";
}
.table-height {
    height: 90%;
}

.amount-tag {
    background-color: #FFEEC4;
    color: #000;
    font: 1.2rem/20px "OpenSans-Regular";
    margin: 0 30px;
}

.table-containertable {
  position: relative;
  max-height: calc(100vh - 250px);
  overflow: hidden; 
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 1800px;
    th,td {
      // width: 100px;
    }
    thead th {
      position: sticky;
      top: 0;
      font-size: 1.0rem;
      color: #005399;
      line-height: 15px;
      letter-spacing: 0.04rem;
      text-transform: uppercase;
      background: #f9f9f9;
      color: #005399;
      padding: 16px 8px 5px 8px;
      font-size: 10px;
      text-transform: uppercase;
      z-index: 0;
      text-align: right;
    }
    thead th:first-child {
      z-index: 10;
      
    }

    thead th:last-child {
      z-index: 10;
    }
    tbody td:first-child,
    thead th:first-child {
      position: sticky;
      left: 0;
      text-align: center;
      background: #f9f9f9;
      border:transparent;
    }
    tbody td:last-child,
    thead th:last-child {
      position: sticky;
      right: 0;
      text-align: center;
      background: #f9f9f9;
      border:transparent;
    }
    tr:nth-child(odd) {
      background-color: #fff;
    }
    tr:hover{
      td{
        background-color: #EFF3F5 !important;
      }
    }
    td{
      text-align: right;
      border: 1px solid #E2EAEC;
      padding: 10px 10px;
      color: #616161;
      text-align: right;
      cursor: pointer;
      font-size: 12px;
      font-weight: 800;
      &.activegreen{
        background: #D5F9D1;
      }
    }
    td:nth-child(1){
      text-align: left;
      border-right: 1px solid #E2EAEC;
    }
    td:last-child {
      text-align: center;
      background: #F8F8F8 !important;
    
    }
  }
}
.table-containertable table th .selDropdown {
  background-color: transparent;
  height: 30px;
  padding: 0;
  font-family: "OpenSans-Bold";
  font-size: 12px;
  text-transform: uppercase;
  border: none;
  color: #58646D;
  &.arrow-adjust{
    .el-icon-arrow-up:before{
      top:-2px !important;
    }
  }
}
.table-containertable table th .selDropdown .el-input__inner {
    background-color: transparent;
    height: 30px;
    padding: 0;
    font-family: "OpenSans-Bold";
    font-size: 12px;
    text-transform: uppercase;
    border: none;
    color: #58646D;
}
.table-containertable{
  .checkcontent {
    &_block {
      padding: 2px 8px 0 0px;
      line-height: 17px;
      cursor: pointer;

      label {
        width: 15px;
        height: 15px;

        .el-checkbox__inner {
          border-color: #B0C3CC;
        }
      }
      %titlepanel {
        font-weight: bold;
        text-transform: uppercase;
        font-size: 14px;
      }
      .tabletitle {
        width: 172px;
        padding-right: 10px;
        font-size: 1.2rem;
        font-family: 'OpenSans-Regular';
        text-wrap: nowrap;
        @extend %titlepanel;
        color: #234357;
      }

      .location {
        margin-top: 3px;
        color: #2F2F2F;
        font-size: 11px;
        font-weight: normal;
        max-width: 160px;
        display: inline-block;
        overflow: hidden;
      }

      .smallbadge{
        position: absolute;
        bottom: 6px;
        right: 12px;
        font-size: 8px;
        color: #234357;
        $fontSemibold: 'OpenSans-SemiBold', sans-serif;
        font-family:$fontSemibold;
        text-transform: uppercase;

        svg {
          position: relative;
          right: 5px;
          top: -3px;
        }
      }

      .arrowError {
        color: #E25757;
        font-size: 8px;
        font-weight: 600;
        .svg-fill{
          fill: #E25757;
        }
      }
    }
  }
}
</style>
